module.exports = __webpack_public_path__ + "static/img/lt.7af3c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/lt.png
// module id = qD1S
// module chunks = 171